import ApiBack from "../../../utils/domains/ApiBack";
import IPS from "../../../models/Ips";
import IPSView from "../../../models/ipsView";
import Municipio from "../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";
import { useForm } from "../../../utils/hooks/useForm";
import { useRef } from "react";
import Deparment from "../../../models/Deparment";
import User from "../../../models/user";
import { jwtDecode } from "jwt-decode";
import { Bell } from "lucide-react";
import EPS from "../../../models/SupportInformation/EPS";

export const ListEPS = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [process, setProcess] = useState<boolean>(false);
  const [dateContract, setDateContract] = useState("");
  const [dateUpdate2025, setDateUpdate2025] = useState("");
  const [dateContract2026, setDateContract2026] = useState("");
  const [arrayEPS, setArrayEPS] = useState<EPS[]>([]);
  const [show, setShow] = useState(false);
  const [showData, setShowData] = useState(false);
  const handleClose = () => setShow(false);
  const [show2, setShow2] = useState(false);
  const [showNoti, setShowNoti] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showUpActivation, setShowUpActivation] = useState(false);
  type formaHtml = React.FormEvent<HTMLFormElement>;
  const handleClose2 = () => setShow2(false);
  const formRef = useRef<HTMLFormElement>(null);
  const [arrayMunicipio, setArrayMunicipio] = useState<Municipio[]>([]);
  const [haveActualization, setHaveActialization] = useState(false);
  const [dataA, setDataA] = useState("");
  const [connectiono, setConnection] = useState("");
  const [passwordServer, setPasswordServer] = useState("");
  const [nameServer, setNameServer] = useState("");
  const [comment, setComment] = useState("");
  const [passwordConnection, setPasswordConnection] = useState("");
  //function to error the Token on the time, using when token is invalid or expired
  const [search, setSearch] = useState("");
  const [arrayUsers, setArrayUsers] = useState<User>();
  const [resumen, setResumen] = useState<any>({});
  const [arrayIPSUpdate, setArrayIPSUpdate] = useState<IPS[]>([]);
  const [showFinal, setShowFinal] = useState(false);
  const [proccess, setProccess] = useState<boolean>();

  let { name_eps, doubleLink, object } =
    useForm<EPS>(
      new EPS(
        0,
        "",
        ""
      ) // Incluye `id_municipio` con un valor inicial
    );

  const [objEps, setObjEps] = useState<IPSView>(
    new IPSView(
      0,
      "",
      "",
      false,
      new Municipio(0, "", "", new Deparment(0, "")),
      new Date(),
      false,
      "",
      new Date(), true, true, "", "", new Date()
    )
  );


  const cleanBox = (form: HTMLFormElement) => {
    form.reset();

    object.name_eps = "";

    (form.querySelector('[name="name_eps"]') as HTMLInputElement).value =
      "";

    form.classList.remove("was-validated");
  };



  const handleTokenError = () => {
    navigate("/");
  };

  const getOneIps = async (id: number) => {
    try {
      const urlGetUser = ApiBack.GET_ID_EPS + "?id=" + id;
      const result = await ServicePrivate.requestGET(urlGetUser);

      setObjEps(result);
      setShow(true);
    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const getIPSUpdate = async () => {
    try {
      const urlGetMunc = ApiBack.IPS_UPDATE_STATUS;
      const result = await ServicePrivate.requestGET(urlGetMunc);

      if (result) {
        setArrayIPSUpdate(result);
      }
      if (result.error) {
        MessageToastify("error", result.error, 3000)
      }
    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const handleShowCreate = async () => {
    setShow2(true);
  }

  const getOneIpsUp = async (id: number) => {
    try {
      const urlGetUser = ApiBack.IPS_LIST_ONE + "/" + id;
      const result = await ServicePrivate.requestGET(urlGetUser);
      setObjEps(result);
      setShowUpdate(true);
      setDateContract(result.date_contract)
      setDateUpdate2025(result.date_update2025)
      setHaveActialization(result.have_actualization)
      setConnection(result.connection)
      setPasswordConnection(result.password_connection)
      setNameServer(result.name_server)
      setPasswordServer(result.password_server)
      setDateContract2026(result.date_contract2026)
      setComment(result.comment || "")

    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const getAllEPS = async () => {
    try {
      const results = await ServicePrivate.requestGET(ApiBack.lIST_EPS_ALL);

      if (results) {
        const payload = results || [];
        setArrayEPS(payload);
        setLoading(false);
      } else {
        setLoading(true);
      }
    } catch (error) {
      console.error("Error fetching EPS:", error);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };


  const getProfessionals = async () => {
    try {
      const token: any = localStorage.getItem("access");
      if (!token) {
        handleTokenError();
        return;
      }
      const decoded: any = jwtDecode(token);

      if (decoded && decoded.role) {
        setArrayUsers(decoded);
        setLoading(false);
        return;
      } else {
        console.error("El token no contiene información de usuario válida.");
        handleTokenError();
      }

    } catch (error) {
      console.error("Error fetching professionals:", error);
      setLoading(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };


  const sendForm = async (fh: formaHtml) => {
    try {
      fh.preventDefault();
      setProcess(true);
      const form = fh.currentTarget;

      form.classList.add("was-validated");

      if (form.checkValidity() === false) {
        fh.preventDefault();
        fh.stopPropagation();
        setProcess(false);
        MessageToastify(
          "error",
          "Por favor, completa todos los campos requeridos.",
          3000
        );
        return;
      }

      const formData = {
        name_eps: object.name_eps,
      };

      const response = await ServicePrivate.requestPOST(
        ApiBack.CREATE_EPS,
        formData
      );

      if (response.OK) {
        setProcess(false);
        MessageToastify(
          "error",
          "Error al momento de crear la nueva EPS.",
          5000
        );
      } else {
        setProcess(false);
        handleClose2();
        getAllEPS();
        MessageToastify("success", "La nueva EPS ha sido creado correctamente.", 3000);
        cleanBox(form)
      }
    } catch (error) {
      setProcess(false);

      MessageToastify(
        "error",
        "Error en el momento  crear el nuevo cliente.",
        7000
      );
    }
  };

  useEffect(() => {
    getAllEPS();
    getProfessionals();
    getIPSUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const updateSupportDetails = async (myipsid: number, isActive: boolean) => {
    setProccess(true);

    try {
      // Encuentra el soporte por ID en el array
      const updatedSupport = arrayEPS.find((myIps) => myIps.id === myipsid);

      if (!updatedSupport) {
        console.error("Soporte no encontrado");
        return;
      }

      // Crea un objeto con el valor de is_active basado en el parámetro
      const updatedObject = {
        is_active: isActive,
      };

      const urlUpdate = ApiBack.UPDATE_STATE_EPS + "?id=" + myipsid;
      const response = await ServicePrivate.requestPUT(
        urlUpdate,
        updatedObject
      );

      if (response.data.OK) {
        MessageToastify(
          "error",
          "Error en el momento de Actualizar el estado de la EPS.",
          3000
        );
        getAllEPS();
      } else {
        MessageToastify("success", "El estado de la EPS esta actualizado correctamente.", 3000);
        setShowFinal(false);
        getAllEPS();
      }
    } catch (error) {
      console.error("Error actualizando el estado de la EPS:", error);
      MessageToastify(
        "error",
        "Error en el momento de actualizar el estado de la EPS en el servidor, contactar con TI.",
        3000
      );
      setShow(false);
    } finally {
      setProccess(false);
      setShow(false);
    }
  };

  return (
    <>
      <div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4 col-sm-4">
                    <h4 className="card-title fs-4 fw-bold">
                      <i className="fa-solid fa-list"></i>&nbsp;Listado de EPS
                    </h4>

                  </div>
                  <div className="col-lg-4 col-sm-4">
                    <input
                      type="text"
                      placeholder="Buscar IPS por municipio o por nombre."
                      className="form-control mb-2"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-4 col-sm-4">
                    <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                      <div className="position-relative d-inline-block">
                        <button
                          type="button"
                          className="btn btn-link position-relative p-2"
                          onClick={() => { setShowNoti(!showNoti); }}
                        >
                          <Bell className="h-5 w-5 text-dark" strokeWidth={2.5} />
                          {arrayIPSUpdate.length > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark">
                              {arrayIPSUpdate.length}
                            </span>
                          )}
                        </button>
                      </div>
                      <button
                        className={
                          "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                        }
                        type="button"
                        onClick={() => handleShowCreate()}
                        style={{ marginLeft: "10px" }}
                      >
                        <i className="fa-solid fa-plus"></i>&nbsp;Crear
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row d-flex justify-center">
                  <div className="col-lg-2 col-md-2">
                    <p>
                      Total de ips:&nbsp;
                      <b className="fw-bold">{arrayEPS.length}</b>
                    </p>
                  </div>
                </div>

                <div className="table-responsive rounded-table" style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  zIndex: 1020
                }}>

                  <table className="table table-striped table-sm table-hover table-sm">
                    <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                      <tr>
                        <th style={{ width: "50%" }}>Nombre EPS</th>
                        <th style={{ width: "50%" }}></th>
                      </tr>
                    </thead>
                    <tbody className="table-group-divider ">
                      {arrayEPS.map((myIps, count) => (
                        <tr key={count + 1}>
                          <td>
                            <span className={`cursor-pointer ${myIps.is_active
                              ? ""
                              : "text-gray"
                              }`}>
                              {myIps.name_eps}
                            </span>
                          </td>
                          <td className="d-flex justify-content-center">
                            {arrayUsers?.role === "ADMINISTRADOR" ? (
                              <>
                                <button
                                  className={
                                    myIps.is_active
                                      ? "badge fs-6 py-1 pe-1 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill"
                                      : "badge fs-6 py-1 pe-3 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                  }
                                  type="button"
                                  onClick={() => getOneIps(myIps.id)}

                                >
                                  {myIps.is_active ? (
                                    <>
                                      <i className="fa-regular fa-circle-xmark"></i>
                                      &nbsp;Inactivar
                                    </>
                                  ) : (
                                    <>
                                      <i className="fa-regular fa-circle-check"></i>
                                      &nbsp;Activar
                                    </>
                                  )}
                                </button>
                              </>
                            ) : ("")}

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="d-flex align-items-center justify-content-center m-3"></div>
                </div>

                <Modal
                  show={show2}
                  onHide={handleClose2}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      <i className="fa-solid fa-folder-plus"></i>
                      &nbsp;Formulario de creación
                    </Modal.Title>
                  </Modal.Header>
                  <Form
                    className="forms-sample"
                    validated={process}
                    onSubmit={sendForm}
                    noValidate
                    ref={formRef}
                  >
                    <Modal.Body>
                      {/* Campo para nombre_ips */}
                      <Form.Group controlId="name_eps" className="mb-3 w-100">
                        <Form.Label
                          className="fw-bold mb-2 mt-2"
                          htmlFor="name_eps"
                        >
                          Nombre de la EPS:
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="name_eps"
                          className="form-control"
                          id="name_eps"
                          placeholder="Escriba el nombre de la EPS"
                          value={name_eps}
                          onChange={(e) => {
                            let value = e.target.value.toUpperCase(); // Convierte a mayúsculas
                            // Validar que solo contenga letras y limitar a 60 caracteres
                            if (
                              /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*$/.test(value) &&
                              value.length <= 60
                            ) {
                              e.target.value = value; // Establece el valor en mayúsculas
                              doubleLink(e); // Llama a tu función existente
                            }
                          }}
                          autoComplete="off"
                          maxLength={60} // Limita a 60 caracteres
                        />
                        <Form.Control.Feedback type="invalid">
                          Nombre de la EPS es obligatorio.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="danger" onClick={handleClose2}>
                        <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                      </Button>
                      <Button
                        variant="success"
                        type="submit"
                        onClick={() => { }}
                      >
                        <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                      </Button>
                    </Modal.Footer>
                  </Form>
                </Modal>

                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      {objEps.is_active ? "Inactivar la IPS" : "Activar la IPS"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    ¿Realmente desea cambiar el estado de la IPS?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="danger"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <i className="fa-solid fa-backward"></i>
                      &nbsp;Cancelar
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => {
                        updateSupportDetails(objEps.id, !objEps.is_active);
                      }}
                    >
                      <i className="fa-solid fa-circle-check"></i>
                      &nbsp;Confirmar
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};
